<template>
  <v-dialog :value="isOpen" @input="$emit('input', $event)" max-width="640px">
    <v-card>
      <v-card-title class="headline">
        {{ $t('global.adminEventCode.deprecateAndCreateNew') }}
      </v-card-title>
      <v-card-text>
        <p class="mb-4">
          {{ $t('global.adminEventCode.deprecateDialogText') }}
        </p>
        <v-text-field
          v-model="newName"
          :label="$t('global.id')"
          :error-messages="nameErrors"
          @blur="touchName()"
          filled
          autofocus
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">{{ $t('global.cancel') }}</v-btn>
        <v-btn color="warning" :loading="loading" :disabled="!canSubmit" @click="submit">
          {{ $t('global.adminEventCode.deprecateAndCreateNew') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { eventCodeDeprecate } from '@/graphql/mutations/eventCodeDeprecate'

export default {
  name: 'DeprecateEventDialog',
  model: { prop: 'isOpen', event: 'input' },
  props: {
    isOpen: Boolean,
    eventCode: Object,
  },
  data() {
    return {
      newName: '',
      loading: false,
      touched: false,
    }
  },
  computed: {
    canSubmit() {
      return this.newName.trim().length > 0 && !this.loading
    },
    nameErrors() {
      if (!this.touched) return []
      if (this.newName.trim() === '') return [this.$t('global.nameTakenError')]
      return []
    },
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.newName = `${this.eventCode?.name || ''}_v2`
        this.touched = false
        this.loading = false
      }
    },
  },
  methods: {
    touchName() {
      this.touched = true
    },
    async submit() {
      if (!this.canSubmit) return
      this.loading = true
      try {
        const { data } = await this.$apollo.mutate({
          mutation: eventCodeDeprecate,
          variables: {
            data: {
              eventCodeId: this.eventCode.id,
              newName: this.newName.trim(),
            },
          },
          refetchQueries: ['eventCodesAdmin'],
        })
        this.$emit('input', false)
        this.$emit('created', data.eventCodeDeprecate.newEventCodeId)
        this.$toast.success(this.$t('global.success'))
      } catch (error) {
        const parsedError = error.message?.replace('GraphQL error:', '').trim()
        const friendly =
          parsedError === 'EVENT_CODE_CREATE_NAME_TAKEN' ||
          parsedError === 'EVENT_CODE_UPDATE_NAME_TAKEN'
            ? this.$t('global.nameTakenError')
            : this.$t('global.failure')
        this.$toast.error(friendly)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
